export default {"src":"/_next/static/media/ftIcon2.0a0ca9b9.svg","height":66,"width":68};